export default class heyflowModal {
    constructor(element) {
        this.element = element
        this.focusContent = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
        this.modal = this.element.parentNode?.querySelector('heyflow-wrapper')
        this.element.addEventListener('click', this.setFocusToClosestElement.bind(this))
        this.modal.addEventListener('keydown', this.handleFocusTrap.bind(this))
    }

    // set focus to first Item that is display none or in a display none container
    setFocusToClosestElement(e) {
        if (!this.modal || !this.modal.shadowRoot) {
            return
        }

        const modalInputs = this.modal?.shadowRoot?.querySelectorAll(this.focusContent)

        for (let i = 0; i < modalInputs.length; i++) {
            if (this.isDisplayNone(modalInputs[i])) {
                continue
            }
            modalInputs[i].focus()
            break
        }
    }

    // Check if element or any of its parents has property display:none
    isDisplayNone(element) {
        let currentElement = element
        while (currentElement) {
            if (currentElement instanceof ShadowRoot) {
                return false
            }

            const style = window?.getComputedStyle(currentElement)

            if (style.display === 'none' || currentElement.style.display === 'none') {
                return true
            }

            // set Element and Check again if not null
            currentElement = currentElement.parentNode
        }
        return false
    }

    // TODO: handle focus trapping
    handleFocusTrap(e) {
        const shadowRoot = this.modal.shadowRoot
        const firstFocusElement = shadowRoot.querySelector(this.focusContent)
        const focusElements = shadowRoot.querySelectorAll(this.focusContent)
        const lastFocusElement = focusElements[focusElements.length - 1]
    }
}
